import type { Address as AddressType } from "@/types";

export default class Address {
  streetAddress: string;
  postalCode: string;
  city: string;
  country: string;

  constructor({ street_address: streetAddress, postal_code: postalCode, city, country }: AddressType) {
    this.streetAddress = streetAddress;
    this.postalCode = postalCode;
    this.city = city;
    this.country = country;
  }
}
